import IndexeddbCache from './indexeddb';

const Cache = {
	initIndexedDb(...args) {
		return new IndexeddbCache(...args);
	}
};

export default Cache;
